import React from "react";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import { ContentBlock, StdGrid, StdToolbar, createBoolColumn, createGridOptions, stdReadOnlyGridOptions, createEncryptedStringColumn} from "../../components";
import { fillingUserStore } from "../../api";
import AuthorizedComponent from "../authorized-component";
import { dataSources, enums } from "../../base";
import { FillingUserModel } from "../../models";

export default class FillingUserPage extends AuthorizedComponent {
    objectName = "FillingUser";
    moduleName = "FillingUser";
    gridRef = React.createRef<DataGrid>();
    toolbarRef = React.createRef<StdToolbar>();
    gridOptions = createGridOptions("fillingUsers", this.gridRef, stdReadOnlyGridOptions);
    columns: IColumnProps[] = [
        { dataField: 'code' },
        { dataField: 'name' },
        { 
            dataField: 'post',
            lookup: { dataSource: dataSources.fillingUserPosts, displayExpr: 'text', valueExpr: 'value' }
        },
        createEncryptedStringColumn({ dataField: 'phoneNumber' }),
        createBoolColumn({ dataField: 'deleted' })
    ];

    constructor(props: Readonly<any>) {
        super(props);

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = e => this.onButtonClick(e.data, "edit");
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.toolbarRef.current?.setModel(e.selectedRowsData[0]);
        } else {
            this.toolbarRef.current?.setModel({});
        }
    }

    onButtonClick(model: FillingUserModel, name: string) {
        const grid = this.gridRef.current?.instance;
        
        if (grid) {
            switch (name) {
                case "add":
                    if (this.permissions[enums.stdActions.create]) {
                        grid.addRow();
                    }
                    break;

                case "edit":
                    if (this.permissions[enums.stdActions.update]) {
                        grid.editRow(grid.getRowIndexByKey(model.code));
                    }
                    break;
                
                case "delete":
                    if (this.permissions[enums.stdActions.delete]) {
                        grid.deleteRow(grid.getRowIndexByKey(model.code));
                    }
                    break;
            }
        }
    }

    render() {
        return (
            <ContentBlock caption={"充装员工"}>
                <StdToolbar 
                    permissions={this.permissions} 
                    ref={this.toolbarRef} 
                    onButtonClick={this.onButtonClick} />
                <StdGrid
                    moduleName={this.moduleName}
                    gridRef={this.gridRef}
                    dataSource={fillingUserStore}
                    options={this.gridOptions}
                    columns={this.columns}
                    popupWidth={400}
                    popupHeight={360}
                    formColCount={1} />
            </ContentBlock>
        );
    }
}